import { BaseProvider } from 'src/app/core/services/base-provider';
import * as i0 from "@angular/core";
import * as i1 from "./globals.service";
import * as i2 from "@angular/common/http";
import * as i3 from "./ls-helper.service";
export class ProcessService extends BaseProvider {
    constructor(globals, http, ls) {
        super();
        this.globals = globals;
        this.http = http;
        this.ls = ls;
        this.itemToEdit = {};
        this.processTypes = [];
        this.categories = {};
        this.filteredCategories = {};
        this.parentCategories = [];
        this.childCategories = [];
        this.baseUrl = "processType";
    }
    searchProcessTypesByTerm(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/searchTerm/' + params.term +
                '/page/' + params.pageNumber +
                '/size/' + params.pageSize;
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.processTypes = data.Data;
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    searchByCategoryAndTerm(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/category/' + params.categoryId +
                '/searchTerm/' + params.term;
            this.http
                .get(this.url)
                .subscribe((data) => {
                resolve(this.setupCategoryTypes(data.Data));
            }, err => { reject(err); });
        });
    }
    setupCategoryTypes(data) {
        var parentCategories = data.ParenteCategories;
        var childCategories = data.ChildCategories;
        var processTypes = data.ProcessTypes;
        parentCategories.forEach((parentCategory) => {
            parentCategory.processTypes = [];
            parentCategory.childCategories = [];
            data.ProcessTypes.forEach((processType) => {
                if (processType.CategoryId == parentCategory.Id) {
                    parentCategory.processTypes.push(processType);
                }
            });
            data.ChildCategories.forEach((childCategory) => {
                var newChildCategory = {};
                Object.assign(newChildCategory, childCategory);
                newChildCategory.processTypes = [];
                if (newChildCategory.ParentCategoryId == parentCategory.Id) {
                    data.ProcessTypes.forEach((processType) => {
                        if (processType.CategoryId == newChildCategory.Id) {
                            newChildCategory.processTypes.push(processType);
                        }
                    });
                    parentCategory.childCategories.push(newChildCategory);
                }
            });
        });
        // if(parentCategories.length == 0 && processTypes.length > 0){
        // 	parentCategories.CategoryDescription = processTypes[0].CategoryDescriptionParent;
        // 	parentCategories.CategoryLabel = processTypes[0].CategoryLabelParent;
        // 	parentCategories.FileName = processTypes[0].FileNameParent;
        // 	parentCategories.OrderIndex = processTypes[0].OrderIndexParent;
        // 	parentCategories.ParentCategoryId = processTypes[0].ParentCategoryIdParent;
        // 	parentCategories.processTypes = processTypes
        // }
        return parentCategories;
    }
    getAllCategories() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/categories';
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.categories = data.Data;
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getLookups() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/lookup';
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.lookups = data.Data;
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getProcess(id) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/' + id;
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.itemToEdit = data.Data;
                resolve(data);
            }, err => { reject(err); });
        });
    }
    getProcessTypes(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/search/page/' + params.pageNumber +
                '/size/' + params.pageSize +
                '?term=' + params.term;
            this.http.get(this.url)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    create(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl;
            this.http
                .post(this.url, params)
                .subscribe((data) => {
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    update(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + "/" + params.Id;
            this.http
                .put(this.url, params)
                .subscribe((data) => {
                this.itemToEdit = (params);
                resolve(data);
            }, err => { reject(err); });
        });
    }
    delete(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + "/" + params.id;
            this.http
                .delete(this.url)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
}
ProcessService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProcessService_Factory() { return new ProcessService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.LsHelperService)); }, token: ProcessService, providedIn: "root" });
